export default "__VITE_ASSET__ibdVELbB__"